function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.04894 1.92705C9.3483 1.00574 10.6517 1.00574 10.9511 1.92705L12.4697 6.60081C12.6035 7.01284 12.9875 7.2918 13.4207 7.2918H18.335C19.3037 7.2918 19.7065 8.53141 18.9228 9.10081L14.947 11.9894C14.5966 12.244 14.4499 12.6954 14.5838 13.1074L16.1024 17.7812C16.4017 18.7025 15.3472 19.4686 14.5635 18.8992L10.5878 16.0106C10.2373 15.756 9.7627 15.756 9.41221 16.0106L5.43648 18.8992C4.65276 19.4686 3.59828 18.7025 3.89763 17.7812L5.41623 13.1074C5.5501 12.6954 5.40345 12.244 5.05296 11.9894L1.07722 9.10081C0.293507 8.53141 0.696283 7.2918 1.66501 7.2918H6.57929C7.01252 7.2918 7.39647 7.01284 7.53035 6.60081L9.04894 1.92705Z",
  stroke: "#6F62FF"
});

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "-8 -8 36 36",
    fill: "currentColor",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.5e01e710.svg";
export { ForwardRef as ReactComponent };